var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3,10.2L23.2,0h-2.1l-7.8,8.8L7.1,0H0l9.4,13.3L0,24h2.1l8.2-9.3l6.5,9.3H24L14.3,10.2L14.3,10.2z  M11.4,13.5l-0.9-1.3L2.9,1.6h3.3l6.1,8.5l0.9,1.3l7.9,11.1h-3.3L11.4,13.5L11.4,13.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXFooter);
export default __webpack_public_path__ + "static/media/x_footer.0ec04d835f3d4aab5e51b411b0b08d47.svg";
export { ForwardRef as ReactComponent };